import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

import './index.css';
import './libs/i18n/i18n.js';
import {BaseURLProvider} from "./context/BaseURLContext";
import { logAudit } from './utils/logAudit';

// Captura errores JS globales
window.onerror = function (message, source, lineno, colno, error) {
    logAudit({
        state: 'ERROR',
        message: `${message} at ${source}:${lineno}:${colno}`,
        args: { stack: error && error.stack }
    });
};

// Captura promesas no manejadas
window.addEventListener('unhandledrejection', function (event) {
    logAudit({
        state: 'ERROR',
        message: event.reason?.message || 'Unhandled Promise rejection',
        args: { stack: event.reason?.stack }
    });
});

// Hook para warnings de consola
const origWarn = window.console.warn;
window.console.warn = function (...args) {
    logAudit({
        state: 'WARN',
        message: args.map(a => (typeof a === 'string' ? a : JSON.stringify(a))).join(' | '),
        args: { source: 'console.warn' }
    });
    origWarn.apply(window.console, args);
};


ReactDOM.createRoot(document.getElementById('root')).render(

    <BrowserRouter basename="/mifirma-lite">
        <BaseURLProvider>
            <App />
        </BaseURLProvider>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
